export const profileAttachmentServerBase =
  typeof process.env.REACT_APP_SERVER_URL === 'string'
    ? process.env.REACT_APP_SERVER_URL.replace(/\/$/, '')
    : '';

export function attachmentPreviewUrl(fileId) {
  if (!fileId) return '#';
  return `${profileAttachmentServerBase}/api/files/preview/${fileId}`;
}

export function attachmentDownloadUrl(fileId) {
  if (!fileId) return '#';
  return `${profileAttachmentServerBase}/api/files/download/${fileId}`;
}

/** @param {unknown} bytes */
export function formatAttachmentSize(bytes) {
  const n =
    typeof bytes === 'bigint'
      ? Number(bytes)
      : typeof bytes === 'string'
        ? Number(bytes)
        : typeof bytes === 'number'
          ? bytes
          : NaN;
  if (!Number.isFinite(n) || n < 0) return '';
  if (n < 1024) return `${n} B`;
  const kb = n / 1024;
  if (kb < 1024) return `${kb >= 100 ? kb.toFixed(0) : kb.toFixed(1)} KB`;
  const mb = kb / 1024;
  return `${mb >= 100 ? mb.toFixed(0) : mb.toFixed(1)} MB`;
}

/** @param {unknown} file */
export function normalizeProfileFileDescriptor(file) {
  if (!file || file.id == null) return null;
  return {
    id: file.id,
    originalName: file.originalName || file.original_name || `File #${file.id}`,
    mimeType: file.mimeType || file.mime_type || '',
    size: file.size ?? file.file_size ?? file.fileSize ?? null,
  };
}
